import { v4 as uuid } from 'uuid'

export const productList = [
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'laptop',
    price: 5000000,
    thumbnailUrl:
      'https://cdn.tgdd.vn/Products/Images/44/263977/TimerThumb/acer-travelmate-b3-tmb311-31-p49d-n5030-nxvnfsv005-(25).jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'mang-hinh',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/650783_418129_01_front_thumbnail.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'may-ban',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/0649997_408831.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'may-ban',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/0649997_408831.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'mang-hinh',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/650783_418129_01_front_thumbnail.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'mang-hinh',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/650783_418129_01_front_thumbnail.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'mang-hinh',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/650783_418129_01_front_thumbnail.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'laptop',
    price: 5000000,
    thumbnailUrl:
      'https://cdn.tgdd.vn/Products/Images/44/263977/TimerThumb/acer-travelmate-b3-tmb311-31-p49d-n5030-nxvnfsv005-(25).jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'laptop',
    price: 5000000,
    thumbnailUrl:
      'https://cdn.tgdd.vn/Products/Images/44/263977/TimerThumb/acer-travelmate-b3-tmb311-31-p49d-n5030-nxvnfsv005-(25).jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'laptop',
    price: 5000000,
    thumbnailUrl:
      'https://cdn.tgdd.vn/Products/Images/44/263977/TimerThumb/acer-travelmate-b3-tmb311-31-p49d-n5030-nxvnfsv005-(25).jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'mang-hinh',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/650783_418129_01_front_thumbnail.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'mang-hinh',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/650783_418129_01_front_thumbnail.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'laptop',
    price: 5000000,
    thumbnailUrl:
      'https://cdn.tgdd.vn/Products/Images/44/263977/TimerThumb/acer-travelmate-b3-tmb311-31-p49d-n5030-nxvnfsv005-(25).jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'laptop',
    price: 5000000,
    thumbnailUrl:
      'https://cdn.tgdd.vn/Products/Images/44/263977/TimerThumb/acer-travelmate-b3-tmb311-31-p49d-n5030-nxvnfsv005-(25).jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'laptop',
    price: 5000000,
    thumbnailUrl:
      'https://cdn.tgdd.vn/Products/Images/44/263977/TimerThumb/acer-travelmate-b3-tmb311-31-p49d-n5030-nxvnfsv005-(25).jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'mang-hinh',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/650783_418129_01_front_thumbnail.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'mang-hinh',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/650783_418129_01_front_thumbnail.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'mang-hinh',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/650783_418129_01_front_thumbnail.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'mang-hinh',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/650783_418129_01_front_thumbnail.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'mang-hinh',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/650783_418129_01_front_thumbnail.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'may-ban',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/0649997_408831.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'mang-hinh',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/650783_418129_01_front_thumbnail.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'mang-hinh',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/650783_418129_01_front_thumbnail.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'may-ban',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/0649997_408831.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'mang-hinh',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/650783_418129_01_front_thumbnail.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'mang-hinh',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/650783_418129_01_front_thumbnail.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'mang-hinh',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/650783_418129_01_front_thumbnail.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'may-ban',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/0649997_408831.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'may-ban',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/0649997_408831.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'may-ban',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/0649997_408831.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'may-ban',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/0649997_408831.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'may-ban',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/0649997_408831.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'may-ban',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/0649997_408831.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'may-ban',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/0649997_408831.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'may-ban',
    price: 5000000,
    thumbnailUrl:
      'https://90a1c75758623581b3f8-5c119c3de181c9857fcb2784776b17ef.ssl.cf2.rackcdn.com/0649997_408831.jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      VGA: null,
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
]
